'use strict';

namespace Core {
    type INgModelController = angular.INgModelController;
    type IScope = ng.IScope;

    class PaymentAmountSelection {
        private maxValue: number;
        private partPaymentAmount: number | undefined;
        private currencySymbol: string;
        private currencyCode: string;
        private payFull: boolean = true;
        private paymentAmount: INgModelController;

        constructor(
            private currencyService,
            private $scope: IScope
        ) {
            this.currencySymbol = this.currencyService.getSymbol(this.currencyCode);

            let partPaymentAmountWatch;
            this.$scope.$watch('cm.payFull', payFull => {
                if (payFull) {
                    this.paymentAmount.$setViewValue(this.maxValue);
                    partPaymentAmountWatch && partPaymentAmountWatch();
                    this.partPaymentAmount = undefined;
                } else {
                    partPaymentAmountWatch = this._setPartPaymentAmountWatch();
                }
            });
        }

        _setPartPaymentAmountWatch() {
            return this.$scope.$watch('cm.partPaymentAmount', val => {
                this.paymentAmount.$setViewValue(val);
            });
        }
    }

    angular
        .module('core')
        .component('paymentAmountSelection', {
            require: {
                form: '?^form',
                paymentAmount : 'ngModel'
            },
            bindings: {
                maxValue: '@',
                currencyCode: '@',
                payFull: '='
            },
            controller: PaymentAmountSelection,
            controllerAs: 'cm',
            templateUrl: 'partials/dashboard/paymentamountselection'
        });
}
